export const SPACE_CHILD_TYPES = [
    { label: 'SINGLE', name: 'SINGLE', value: 'SINGLE' },
    { label: 'MULTIPLE', name: 'MULTIPLE', value: 'MULTIPLE' },
    { label: 'UNDEFINED', name: 'UNDEFINED', value: 'UNDEFINED' },
]